import React from 'react';
import QuestionCircle from '@svg/question-circle.svg?react';
import AdvancedThreatProtection from '@svg/advanced-threat-protection-small.svg?react';
import Network from '@svg/domains.svg?react';
import { DefaultMessage } from 'src/model/chat-bot';

export const defaultMessages: DefaultMessage[] = [
    {
        title: 'Ask me anything about Dynamic Defense',
        icon: <QuestionCircle/>,
        sample: '<b>What would you like to know?</b>\n' +
            '<small>For example</small>\nHow to use policy manager?\nHow to pull a policy?\nHow to create a Geo-Filtering Policy?\nHow to view reporting?'
    },
    {
        title: 'Make policy changes directly from this chat',
        icon: <AdvancedThreatProtection/>,
        sample: '<b>What would you like to change?</b>\n' +
            '<small>For example</small>\nBlock high risk countries traffic for both directions\nBlock or Allow specific domains\n' +
            'Block or allow specific apps\nBlock or allow specific services'
    },
    {
        title: 'Ask me anything about your network activity',
        icon: <Network/>,
        sample: '<b>What would you like to know?</b>\n' +
            '<small>For example</small>\nWas facebook traffic blocked in the past week?\nWhat are the 20 top blocked countries?\nWhich app has most blocked traffic?'
    }
];

export const GENERIC_CHAT_ERROR = 'Something went wrong. Please try again later';
export const MAX_INPUT_CHAT_MESSAGE_LENGTH = 500;

